/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/comp_projects-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/comp_projects-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/comp_projects-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-comp_projects-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/comp_projects.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/comp_projects-entity-config.ts
 * Public fields: 26/26 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const CompProjectsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  subject_property_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // subject_property_id field
  comp_type_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // comp_type_id field
  review_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // review_status_id field
  title: Type.Union([Type.String(), Type.Null()]), // title field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  created_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // updated_by_user_profile_id field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
  request_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // request_status_id field
  origin: Type.Union([Type.String(), Type.Null()]), // origin field
  escalated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // escalated_at field
  subject_property_freetext: Type.Union([Type.String(), Type.Null()]), // subject_property_freetext field
  subject_property_freetext_hint: Type.Union([Type.String(), Type.Null()]), // subject_property_freetext_hint field
  requested_deadline: Type.Union([Type.String(), Type.Null()]), // requested_deadline field
  submitted_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // submitted_at field
  first_touched_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // first_touched_at field
  fulfilled_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // fulfilled_at field
  assigned_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // assigned_user_profile_id field
  assigned_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // assigned_at field
  assigned_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // assigned_by_user_profile_id field
  archived_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // archived_at field
  archived_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // archived_by_user_profile_id field
  archive_reason: Type.Union([Type.String(), Type.Null()]), // archive_reason field
  archive_batch_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // archive_batch_id field
});

export const CreateCompProjectsSchema = Type.Object({
  subject_property_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // subject_property_id field
  comp_type_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // comp_type_id field
  review_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // review_status_id field
  title: Type.Optional(Type.Union([Type.String(), Type.Null()])), // title field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
  created_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // updated_by_user_profile_id field
  request_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // request_status_id field
  origin: Type.Optional(Type.Union([Type.String(), Type.Null()])), // origin field
  escalated_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // escalated_at field
  subject_property_freetext: Type.Optional(Type.Union([Type.String(), Type.Null()])), // subject_property_freetext field
  subject_property_freetext_hint: Type.Optional(Type.Union([Type.String(), Type.Null()])), // subject_property_freetext_hint field
  requested_deadline: Type.Optional(Type.Union([Type.String(), Type.Null()])), // requested_deadline field
  submitted_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // submitted_at field
  first_touched_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // first_touched_at field
  fulfilled_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // fulfilled_at field
  assigned_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // assigned_user_profile_id field
  assigned_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // assigned_at field
  assigned_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // assigned_by_user_profile_id field
});

export const UpdateCompProjectsSchema = Type.Object({
  subject_property_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // subject_property_id field
  comp_type_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // comp_type_id field
  review_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // review_status_id field
  title: Type.Optional(Type.Union([Type.String(), Type.Null()])), // title field
  description: Type.Optional(Type.Union([Type.String(), Type.Null()])), // description field
  created_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // updated_by_user_profile_id field
  request_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // request_status_id field
  origin: Type.Optional(Type.Union([Type.String(), Type.Null()])), // origin field
  escalated_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // escalated_at field
  subject_property_freetext: Type.Optional(Type.Union([Type.String(), Type.Null()])), // subject_property_freetext field
  subject_property_freetext_hint: Type.Optional(Type.Union([Type.String(), Type.Null()])), // subject_property_freetext_hint field
  requested_deadline: Type.Optional(Type.Union([Type.String(), Type.Null()])), // requested_deadline field
  submitted_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // submitted_at field
  first_touched_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // first_touched_at field
  fulfilled_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // fulfilled_at field
  assigned_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // assigned_user_profile_id field
  assigned_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // assigned_at field
  assigned_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // assigned_by_user_profile_id field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type CompProjectsRow = Static<typeof CompProjectsSchema>;
export type CompProjectsInsert = Static<typeof CreateCompProjectsSchema>;
export type CompProjectsUpdate = Static<typeof UpdateCompProjectsSchema>;

// Legacy type aliases for backward compatibility
export type CompProjects = CompProjectsRow;
export type CreateCompProjects = CompProjectsInsert;
export type UpdateCompProjects = Static<typeof UpdateCompProjectsSchema>;

// Field configuration metadata
export const CompProjectsFieldConfig = {
  filterable: ['id', 'subject_property_id', 'comp_type_id', 'review_status_id', 'created_by_user_profile_id', 'updated_by_user_profile_id', 'request_status_id', 'assigned_user_profile_id', 'assigned_by_user_profile_id', 'archived_by_user_profile_id', 'archive_batch_id'] as const,
  sortable: ['created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id'] as const,
  readonly: ['id', 'created_at', 'updated_at', 'archived_at', 'archived_by_user_profile_id', 'archive_reason', 'archive_batch_id'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface CompProjectsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface CompProjectsResponse {
  data: CompProjects[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleCompProjectsResponse {
  data: CompProjects | null;
  error: Error | null;
}
